
(function($){
  $(document).on( 'ready', function(){
    $('.ns-story__img .doc-image-empty').each(function(){
      $(this).parent().hide();
    });
  });
})(jQuery);
